import React, { useState, useEffect } from "react";
import { loginApi, resetPasswordApi } from "../Api/api";
import { useNavigate } from "react-router-dom";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [comCode, setComCode] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const navigate = useNavigate();

  const [captchaText, setCaptchaText] = useState("");
const [userCaptcha, setUserCaptcha] = useState("");
  // Reset password states
  const [showResetModal, setShowResetModal] = useState(false);
  const [resetUsername, setResetUsername] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [resetComCode, setResetComCode] = useState("");
  const [resetMessage, setResetMessage] = useState("");
  const [resetLoading, setResetLoading] = useState(false);

useEffect(() => {
  const reloaded = sessionStorage.getItem("loginPageReloaded");

  if (!reloaded) {
    sessionStorage.setItem("loginPageReloaded", "true");
    window.location.reload();
  }

}, []);


const generateCaptcha = () => {
  const caps = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const small = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";

  const chars = caps + small + numbers;

  let captcha = "";

  for (let i = 0; i < 5; i++) {
    captcha += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  setCaptchaText(captcha);
};

  const handleLogin = async () => {
    if (!username.trim() || !password.trim() || !comCode.trim()) {
      setMessage("Please enter username, password and company code");
      return;
    }

    setLoading(true);
    setMessage("");
    try {
      const data = await loginApi({
        Usrname: username,
        UsrPwd: password,
        ComShortCode: comCode
      });
      if (data.status === "success") {
        // Store user data in localStorage
        const userData = {
          ...data.data,
          ComShortCode: data.data.ComShortCode || comCode // Ensure we have the company short code
        };
        localStorage.setItem("userData", JSON.stringify(userData));
        console.log("Stored userData:", userData);
        navigate("/dashboard");
      } else {
        setMessage(data.message);
      }
    } catch (error) {
      setMessage("Server Error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  // ===== HANDLE RESET PASSWORD =====
  const handleResetPassword = async () => {
    
  if (userCaptcha !== captchaText) {
    setResetMessage("Invalid Captcha");
    generateCaptcha();
    return;
  }

    if (!resetUsername.trim() || !resetEmail.trim() || !resetComCode.trim()) {
      setResetMessage("Please enter username, email and company code");
      return;
    }

    setResetLoading(true);
    setResetMessage("");
    try {
      const data = await resetPasswordApi({
        Usrname: resetUsername,
        Email: resetEmail,
        ComShortCode: resetComCode
      });
      
      if (data.status === "success") {
        setResetMessage("Temporary password sent to registered email");
        // Close modal after success
        setTimeout(() => {
          setShowResetModal(false);
          setResetUsername("");
          setResetEmail("");
          setResetComCode("");
          setResetMessage("");
        }, 2000);
      } else {
        setResetMessage(data.message || "User Not Found");
      }
    } catch (error) {
      setResetMessage("Server Error. Please try again.");
    } finally {
      setResetLoading(false);
    }
  };

  // Inject styles
  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.textContent = `
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
      }
      @keyframes slideDown {
        from { opacity: 0; transform: translateY(-10px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .login-container {
        animation: fadeIn 0.6s ease-out;
      }
      .login-input:focus {
        border-color: #2563eb !important;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
      }
      .login-button:hover:not(:disabled) {
        background-color: #1d4ed8 !important;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4) !important;
      }
    `;
    document.head.appendChild(styleSheet);
    return () => document.head.removeChild(styleSheet);
  }, []);

  const styles = {
    container: {
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "linear-gradient(135deg, #1e3a5f 0%, #0f172a 100%)",
      fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      padding: "20px",
      position: "relative",
      overflow: "hidden"
    },
    backgroundPattern: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: "radial-gradient(circle at 25% 25%, rgba(37, 99, 235, 0.15) 0%, transparent 50%), radial-gradient(circle at 75% 75%, rgba(139, 92, 246, 0.1) 0%, transparent 50%)",
      pointerEvents: "none"
    },
    card: {
      background: "#ffffff",
      width: "100%",
      maxWidth: "400px",
      borderRadius: "16px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.4)",
      overflow: "hidden",
      position: "relative",
      zIndex: 1
    },
    header: {
      background: "linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)",
      padding: "40px 30px 35px",
      textAlign: "center",
      position: "relative"
    },
    headerIcon: {
      width: "64px",
      height: "64px",
      background: "rgba(255, 255, 255, 0.2)",
      borderRadius: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto 16px",
      fontSize: "28px"
    },
    logo: {
      fontSize: "22px",
      fontWeight: "700",
      color: "#fff",
      marginBottom: "6px",
      letterSpacing: "-0.5px"
    },
    subtitle: {
      fontSize: "14px",
      color: "rgba(255, 255, 255, 0.8)",
      fontWeight: "400"
    },
    form: {
      padding: "32px"
    },
    inputGroup: {
      marginBottom: "20px",
      position: "relative"
    },
    label: {
      display: "block",
      marginBottom: "8px",
      fontSize: "13px",
      fontWeight: "600",
      color: "#374151",
      letterSpacing: "0.3px"
    },
    inputWrapper: {
      position: "relative"
    },
    input: {
      width: "100%",
      padding: "14px 16px",
      borderRadius: "10px",
      border: "1.5px solid #e5e7eb",
      fontSize: "14px",
      outline: "none",
      transition: "all 0.2s ease",
      boxSizing: "border-box",
      backgroundColor: "#f9fafb",
      color: "#1f2937"
    },
    inputIcon: {
      position: "absolute",
      left: "14px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#9ca3af",
      fontSize: "16px",
      transition: "color 0.2s ease",
      pointerEvents: "none"
    },
    inputWithIcon: {
      paddingLeft: "42px"
    },
    button: {
      width: "100%",
      padding: "14px",
      backgroundColor: "#2563eb",
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      fontSize: "15px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.2s ease",
      marginTop: "8px",
      letterSpacing: "0.3px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px"
    },
    buttonDisabled: {
      backgroundColor: "#9ca3af",
      cursor: "not-allowed"
    },
    message: {
      marginTop: "16px",
      padding: "12px 16px",
      borderRadius: "8px",
      fontSize: "13px",
      textAlign: "center",
      backgroundColor: "#fef2f2",
      color: "#dc2626",
      border: "1px solid #fecaca",
      animation: "slideDown 0.3s ease"
    },
    footer: {
      textAlign: "center",
      padding: "20px 30px",
      borderTop: "1px solid #f3f4f6",
      fontSize: "12px",
      color: "#9ca3af"
    },
    spinner: {
      width: "18px",
      height: "18px",
      border: "2px solid rgba(255,255,255,0.3)",
      borderRadius: "50%",
      borderTopColor: "#fff",
      animation: "spin 1s ease-in-out infinite"
    },
    resetPassword: {
      textAlign: "right",
      marginTop: "-12px",
      marginBottom: "20px"
    },
    resetLink: {
      fontSize: "12px",
      color: "#2563eb",
      textDecoration: "none",
      cursor: "pointer"
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.backgroundPattern}></div>
      
      <div style={styles.card} className="login-container">
        <div style={styles.header}>
          <div style={styles.headerIcon}>
            📋
          </div>
          <div style={styles.logo}>Production Labeling</div>
          <div style={styles.subtitle}>Sign in to continue</div>
        </div>

        <div style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Username</label>
            <div style={styles.inputWrapper}>
              <span style={{
                ...styles.inputIcon,
                color: focusedField === "username" ? "#2563eb" : "#9ca3af"
              }}>👤</span>
              <input
                type="text"
                placeholder="Enter your username"
                className="login-input"
                style={{
                  ...styles.input,
                  ...styles.inputWithIcon,
                  borderColor: focusedField === "username" ? "#2563eb" : "#e5e7eb",
                  backgroundColor: "#fff"
                }}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onFocus={() => setFocusedField("username")}
                onBlur={() => setFocusedField(null)}
                onKeyPress={handleKeyPress}
              />
            </div>
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Password</label>
            <div style={styles.inputWrapper}>
              <span style={{
                ...styles.inputIcon,
                color: focusedField === "password" ? "#2563eb" : "#9ca3af"
              }}>🔒</span>
              <input
                type="password"
                placeholder="Enter your password"
                className="login-input"
                style={{
                  ...styles.input,
                  ...styles.inputWithIcon,
                  borderColor: focusedField === "password" ? "#2563eb" : "#e5e7eb",
                  backgroundColor: "#fff"
                }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={() => setFocusedField("password")}
                onBlur={() => setFocusedField(null)}
                onKeyPress={handleKeyPress}
              />
            </div>
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Company Code</label>
            <div style={styles.inputWrapper}>
              <span style={{
                ...styles.inputIcon,
                color: focusedField === "comcode" ? "#2563eb" : "#9ca3af"
              }}>🏢</span>
              <input
                type="text"
                placeholder="Enter company code"
                className="login-input"
                style={{
                  ...styles.input,
                  ...styles.inputWithIcon,
                  borderColor: focusedField === "comcode" ? "#2563eb" : "#e5e7eb",
                  backgroundColor: "#fff"
                }}
                value={comCode}
                onChange={(e) => setComCode(e.target.value)}
                onFocus={() => setFocusedField("comcode")}
                onBlur={() => setFocusedField(null)}
                onKeyPress={handleKeyPress}
              />
            </div>
          </div>

          <div style={styles.resetPassword}>
            <span 
              style={styles.resetLink}
             onClick={() => {
  setShowResetModal(true);
  generateCaptcha();
}}
            >Reset Password?</span>
          </div>

          <button
            className="login-button"
            style={{
              ...styles.button,
              ...(loading ? styles.buttonDisabled : {})
            }}
            onClick={handleLogin}
            disabled={loading}
          >
            {loading && <span style={styles.spinner}></span>}
            {loading ? "Signing in..." : "Sign In"}
          </button>

          {message && (
            <div style={styles.message}>
              ⚠️ {message}
            </div>
          )}
        </div>

        <div style={styles.footer}>
  © 2026 RMP Labeling System • 
  <a
    href="http://www.revamptechnologies.com"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      color: "#2563eb",
      textDecoration: "none",
      fontWeight: "600",
      marginLeft: "4px"
    }}
  >
    Revamp
  </a>
</div>
      </div>

      {/* RESET PASSWORD MODAL */}
      {showResetModal && (
        <div style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>
          <div style={{
            background: "#fff",
            borderRadius: "12px",
            padding: "30px",
            width: "100%",
            maxWidth: "380px",
            boxShadow: "0 20px 40px rgba(0,0,0,0.3)"
          }}>
            <div style={{
              fontSize: "20px",
              fontWeight: "700",
              marginBottom: "20px",
              textAlign: "center",
              color: "#1e3a5f"
            }}>
              Reset Password
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Username</label>
              <input
                type="text"
                placeholder="Enter username"
                style={styles.input}
                value={resetUsername}
                onChange={(e) => setResetUsername(e.target.value)}
              />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Email</label>
              <input
                type="email"
                placeholder="Enter your email"
                style={styles.input}
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
              />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Company Code</label>
              <input
                type="text"
                placeholder="Enter company code"
                style={styles.input}
                value={resetComCode}
                onChange={(e) => setResetComCode(e.target.value)}
              />
            </div>

            {resetMessage && (
              <div style={{
                ...styles.message,
                backgroundColor: resetMessage.includes("Successfully") ? "#d1fae5" : "#fef2f2",
                color: resetMessage.includes("Successfully") ? "#065f46" : "#dc2626"
              }}>
                {resetMessage}
              </div>
            )}

            <div style={{ marginTop: "10px" }}>
  <label style={styles.label}>Captcha</label>

  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
    
    <div style={{
      background: "#f3f4f6",
      padding: "10px 14px",
      fontWeight: "bold",
      letterSpacing: "2px",
      borderRadius: "6px",
      fontSize: "18px",
      userSelect: "none"
    }}>
      {captchaText}
    </div>

    <button
      onClick={generateCaptcha}
      style={{
        border: "none",
        background: "#2563eb",
        color: "#fff",
        padding: "8px 10px",
        borderRadius: "6px",
        cursor: "pointer"
      }}
    >
      ↻
    </button>

  </div>

  <input
    type="text"
    placeholder="Enter captcha"
    style={{ ...styles.input, marginTop: "10px" }}
    value={userCaptcha}
    onChange={(e) => setUserCaptcha(e.target.value)}
  />
</div>

            <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
              <button
                style={{
                  ...styles.button,
                  backgroundColor: "#6b7280"
                }}
                onClick={() => {
                  setShowResetModal(false);
                  setResetMessage("");
                }}
              >
                Cancel
              </button>
              <button
                style={{
                  ...styles.button,
                  ...(resetLoading ? styles.buttonDisabled : {})
                }}
                onClick={handleResetPassword}
                disabled={resetLoading}
              >
                {resetLoading ? "Resetting..." : "Reset Password"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;
